import gql from 'graphql-tag';

export default gql`
  mutation removeByIdCompanyMutation($_id: MongoID!) {
    removeByIdCompanyMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
